<template>
  <div class="categories">
    <div class="body">
      <ul class="menu clearfix">
        <li v-for="(item, idx) in menu" :key="idx">
          <router-link
              v-if="item.sub.length > 0"
              :to="{ path: resolvePath(item) }"
              class="item-1 rounded"
              >{{
            item.descricao
          }}</router-link>
          <template v-else>
            <router-link
              :to="{ path: resolvePath(item) }"
              class="item-1 rounded"
            >
              {{ item.descricao }}
            </router-link>
          </template>
          <!-- First Tab -->
          <ul v-if="item.sub.length > 0 && item.descricao === 'IC\'s'" class="sub-menu clearfix">
            <li v-for="(item2, idx2) in item.sub" :key="idx2">
              <router-link
                v-if="!!item2.url"
                :to="{
                  path: item2.url,
                }"
              >
                <span class="text">{{ item2.descricao }}</span>
                <span class="sub" v-if="item2.sub.length > 0">&#8250;</span>
              </router-link>

              <router-link
                v-else
                :to="{
                  path: resolvePath(item2),
                  params: {
                    link: item2.link_externo,
                    categoria: item2.slug,
                    id: item2.id,
                    nome: item2.label,
                  },
                }"
              >
                <span class="text">{{ item2.descricao }}</span>
                <span class="sub" v-if="item2.sub.length > 0">&#8250;</span>
              </router-link>
              <!-- Second Tab -->
              <ul class="sub-menu clearfix" v-if="item2.sub.length > 0">
                <li v-for="(item3, idx3) in item2.sub" :key="idx3">
                  <router-link
                    v-if="!!item3.url"
                    :to="{
                      path: item3.url,
                    }"
                  >
                    <span class="text">{{ item3.descricao }}</span>
                  </router-link>

                  <router-link
                    v-else
                    :to="{
                      path: resolvePath(item3),
                      params: {
                        link: item3.link_externo,
                        categoria: item3.slug,
                        id: item3.id,
                        nome: item3.label,
                      },
                    }"
                  >
                    <span class="text">{{ item3.descricao }}</span>
                    <span class="sub" v-if="item3.sub.length > 0">&#8250;</span>
                  </router-link>
                  <!-- Third -->
                  <ul class="sub-menu clearfix" v-if="item3.sub.length > 0">
                    <li v-for="(item4, idx4) in item3.sub" :key="idx4">
                      <router-link
                        v-if="!!item4.url"
                        :to="{
                          path: item4.url,
                        }"
                      >
                        <span class="text">{{ item4.descricao }}</span>
                        <span class="sub" v-if="item4.sub.length > 0"
                          >&#8250;</span
                        >
                      </router-link>

                      <router-link
                        v-else
                        :to="{
                          path: resolvePath(item4),
                          params: {
                            link: item4.link_externo,
                            categoria: item4.slug,
                            id: item4.id,
                            nome: item4.label,
                          },
                        }"
                      >
                        <span class="text">{{ item4.descricao }}</span>
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    menu: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    resolvePath(item){
      if(item.link_externo) {
        return `/redirect/${item.link_externo}`;
      }
      if(item.url){
        return `${item.url}`;
      }
      return `/categoria/${item.slug}`;
    }
  },
  mounted() {
    console.log(this.menu);
  },
};
</script>

<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0;
}
.clearfix:after {
  content: '.';
  display: block;
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
  visibility: hidden;
  overflow: hidden;
}

.categories {
  width: 100%;
  height: auto;
  padding: 0;
  background: #609;
  .body {
    width: 980px;
    height: auto;
    margin: 0 auto;

    .menu,
    .sub-menu {
      list-style: none;
      // background: #000;
    }

    .menu {
      a {
        text-decoration: none;
        display: block;
        padding: 4px;
        color: #fff;
        font-family: 'VivoType';
        font-weight: bold;
        font-size: 13px;
        // text-transform: uppercase;
        font-weight: 700;
        padding-bottom: 10px;
      }

      li {
        position: relative;
        margin: 0 10px;

        &:hover > .sub-menu {
          display: block;
        }
      }

      > li {
        float: left;
        a {
          display: flex;
          color: white;
          transition: all 0.3s ease-in-out;
          justify-content: space-between;
        }
        border-bottom: 2px solid transparent;

        &:hover {
          a {
            color: #ff9900;
          }
          // background: #444;
          border-bottom: 2px solid #ff9900;
        }
      }
    }

    .sub-menu {
      margin-top: 2px;
      display: none;
      position: absolute;
      min-width: 150px;
      width: auto;
      background: #660099;
      color: white;
      box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.25);
      border-radius: 0px 0px 5px 5px;
      padding: 5px 0;

      > li {
        margin: 0 10px;
        padding: 4px 5px 0px;
        border-radius: 5px !important;
        transition: all 0.3s ease-in-out;

        min-width: 150px;
        width: auto !important;

        a {
          color: white !important;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.15);
          a {
            color: white;
          }
        }
      }

      .sub-menu {
        top: -3px;
        left: 100%;
        border-radius: 5px;
      }
    }
  }
}
</style>
